import { render, staticRenderFns } from "./infoImg.vue?vue&type=template&id=18c91376&scoped=true"
import script from "./infoImg.vue?vue&type=script&lang=js"
export * from "./infoImg.vue?vue&type=script&lang=js"
import style0 from "./infoImg.vue?vue&type=style&index=0&id=18c91376&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18c91376",
  null
  
)

export default component.exports